var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityServerRoom = function SvgFacilityServerRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.882-717Q266-717 251.5-702.382t-14.5 35.5 14.618 35.382 35.5 14.5 35.382-14.618q14.5-14.617 14.5-35.5T322.382-702.5q-14.617-14.5-35.5-14.5m0 414Q266-303 251.5-288.382t-14.5 35.5 14.618 35.382 35.5 14.5 35.382-14.618q14.5-14.617 14.5-35.5T322.382-288.5t-35.5-14.5M120-494v-345h720v345zm60-285v225h600v-225zM120-80v-346h720v346zm60-286v226h600v-226zm0-413v225zm0 413v226z"
  })));
};
export default SvgFacilityServerRoom;